import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { EditGroup } from "../../Components/EditGroup"
import { AutocompleteInput } from "../../Components/Input"
import { LocalizedMessage } from "../../Components/LocalizedMessage"
import { Select } from "../../Components/Select"
import { GetNMEAConfigurationContext } from "./Context"

export function NMEAConfigurationConnectionView() {
  const app = GetApp()!;
  const t = app.getT("NMEAConfigurationView");
  const {
    connect, connecting, connectionType, connectionTypes, selectConnectionType,
    initConnectionTypeOpen, host, port, device, devices,
    edited, error, completedCallback, resetConnection,
  } = GetNMEAConfigurationContext();

  const editableFields = [{ name: "configuration", type: "object", fields: ["device", "host", { name: "port", type: "int" }, "type"] }];
  return (
    <Block key="connection">
      <EditGroup changed={edited} editable={true} editableFields={editableFields} error={error && t("error_" + error)} onSave={connect}>
        <BlockRow>
          <BlockField label={t("connection_type")}>
            <Select button={t("connection_type_" + connectionType)} name="configuration.type" onSelect={selectConnectionType} options={connectionTypes} value={connectionType} initOpen={initConnectionTypeOpen} />
          </BlockField>
          {(connectionType == "tcp") && (
            <>
              <BlockField label={t("connection_host")}>
                <input name="configuration.host" defaultValue={host} required />
              </BlockField>
            </>
          )}
          {(connectionType == "tcp" || connectionType == "udp") && (
            <>
              <BlockField label={t("connection_port")}>
                <input name="configuration.port" defaultValue={port} required />
              </BlockField>
            </>
          )}
          {(connectionType == "usb" || connectionType == "bluetooth") && (
            <>
              <BlockField label={t("connection_device")}>
                <AutocompleteInput name="configuration.device" defaultValue={device} suggestions={devices} required />
              </BlockField>
            </>
          )}
        </BlockRow>
        {app.hasFeature("gps") && connectionType !== "gps" && <BlockRow className="message-text-bigger"><LocalizedMessage message={(m) => m.nmeaSettings.connectionTypeNative} replace={{ tabName: t("step_native"), type: t("connection_type") }} /></BlockRow>}
        {connectionType === "gps" && <BlockRow className="message-text-bigger"><LocalizedMessage message={(m) => m.nmeaSettings.connectionTypeNativeWarning} /></BlockRow>}

        <BlockRow className="block-row-actions block-row-bottom">
          <BlockField>
            <button className="button" onClick={completedCallback}>{t("cancel")}</button>
          </BlockField>
          <BlockField>
            <button className="button" onClick={resetConnection}>{t("reset")}</button>
            {connecting == true ? <span>{t("connecting")}</span> : <button className="button default" type="submit">{app.status?.nmea?.connected ? t("reconnect") : t("connect")}</button>}
          </BlockField>
        </BlockRow>
      </EditGroup>
    </Block>
  );
}
